import React from 'react';

interface IconProps {
  svg: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
  size?: number;
  className?: string;
  width?: number;
  height?: number;
}

const Icon: React.FC<IconProps> = ({
  svg: Svg,
  size = 24,
  className = '',
  width,
  height,
}) => {
  return (
    <Svg
      width={width || size}
      height={height || size}
      className={className}
    />
  );
};

export default Icon;
